/**
 * Off-canvas navigation.
 *
 * Toggles `is-nav-open` on <html>; all animation lives in _nav-drawer.scss.
 * Handles Escape, backdrop click, focus trapping and scroll lock.
 */
window.Blockline = window.Blockline || {};

window.Blockline.navigation = ( function () {
	'use strict';

	var OPEN_CLASS = 'is-nav-open';
	var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

	var root = document.documentElement;
	var toggle, drawer, panel, label, lastFocus;

	function isOpen() {
		return root.classList.contains( OPEN_CLASS );
	}

	function setLabel( open ) {
		if ( ! label ) {
			return;
		}
		label.textContent = open ? label.dataset.labelClose : label.dataset.labelOpen;
	}

	function open() {
		lastFocus = document.activeElement;

		root.style.setProperty( '--scrollbar-gap', window.innerWidth - root.clientWidth + 'px' );
		drawer.inert = false;
		drawer.removeAttribute( 'inert' );
		root.classList.add( OPEN_CLASS );
		toggle.setAttribute( 'aria-expanded', 'true' );
		setLabel( true );

		window.requestAnimationFrame( function () {
			var first = panel.querySelector( 'a[href]' );
			if ( first ) {
				first.focus( { preventScroll: true } );
			}
		} );
	}

	function close( restoreFocus ) {
		root.classList.remove( OPEN_CLASS );
		drawer.inert = true;
		drawer.setAttribute( 'inert', '' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		setLabel( false );

		if ( restoreFocus !== false ) {
			( lastFocus && document.contains( lastFocus ) ? lastFocus : toggle ).focus( { preventScroll: true } );
		}
	}

	// Keep Tab cycling between the toggle and the drawer links.
	function trapFocus( event ) {
		var items = [ toggle ].concat( Array.prototype.slice.call( panel.querySelectorAll( FOCUSABLE ) ) );
		var first = items[ 0 ];
		var last = items[ items.length - 1 ];

		if ( event.shiftKey && document.activeElement === first ) {
			event.preventDefault();
			last.focus();
		} else if ( ! event.shiftKey && document.activeElement === last ) {
			event.preventDefault();
			first.focus();
		}
	}

	function init() {
		toggle = document.querySelector( '[data-nav-toggle]' );
		drawer = document.querySelector( '[data-nav-menu]' );

		if ( ! toggle || ! drawer ) {
			return;
		}

		panel = drawer.querySelector( '.nav-drawer__panel' ) || drawer;
		label = toggle.querySelector( '[data-nav-label]' );

		toggle.addEventListener( 'click', function () {
			if ( isOpen() ) {
				close();
			} else {
				open();
			}
		} );

		drawer.querySelectorAll( '[data-nav-close]' ).forEach( function ( el ) {
			el.addEventListener( 'click', function () {
				close();
			} );
		} );

		// Close when a link is followed (matters for #anchor links on the same page).
		panel.addEventListener( 'click', function ( event ) {
			if ( event.target.closest( 'a[href]' ) ) {
				close( false );
			}
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( ! isOpen() ) {
				return;
			}
			if ( event.key === 'Escape' ) {
				close();
			} else if ( event.key === 'Tab' ) {
				trapFocus( event );
			}
		} );
	}

	return { init: init, open: open, close: close };
} )();